// Generated by `npm run moanokea` (scripts/moanokea.ts) from data/ncei-0303929/ and data/ncrmp-fish-maui-nui/.
// Do not edit by hand: change the script and run it. tests/moanokea.test.ts builds it again and fails if this file is
// not what the archives give.

/**
 * The moano kea's measured figures (M179, `scripts/moanokea.ts` says how): Oʻahu's blue goatfish, 2020 to 2023 (Weng
 * 2025: 110 measured for both lengths, 115 weighed, 40 females' maturity), and NOAA's divers' goatfish at Maui
 * Nui, 2013 to 2024 (2662 fish, 96 of them blue goatfish). MEASURED by the script.
 */
export const MOANOKEA_SURVEY = {
  /** Total length mm = a + b fork length mm (Oʻahu's fish). */
  tlInterceptMm: 6.47762,
  tlSlope: 1.11907,
  /** Weight g = a fork length cm ^ b (Oʻahu's fish). */
  weightA: 0.0239775,
  weightB: 2.9485,
  /** The females half mature at a fork length mm, and the logistic's slope a mm (Oʻahu's fish). */
  femaleHalfMatureForkMm: 250.179,
  femaleMaturityPerMm: 0.0570096,
  /** The blue goatfish's share of Maui Nui's goatfish by weight at the sizes the roi takes, and at every size. */
  roiShare: 0.0119,
  weightShare: 0.126,
} as const;
